import React, { useMemo, useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    BarElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin
);

const GroupedBarChart = ({ JSONdata }) => {
    const countsByAgeAndGender = useMemo(() => {
        const counts = {};
        JSONdata.forEach((obj) => {
            const age = obj.Age;
            const gender = obj.Gender;
            if (!counts[age]) {
                counts[age] = { Male: 0, Female: 0 };
            }
            counts[age][gender]++;
        });
        return Object.entries(counts).map(([age, counts]) => ({
            Age: age,
            Male: counts.Male,
            Female: counts.Female,
        }));
    }, [JSONdata]);

    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        if (!countsByAgeAndGender) return;
        const sortedData = countsByAgeAndGender; // data is already sorted, but you can sort it here if needed
        const labels = sortedData.map(entry => entry.Age);
        const totalMale = sortedData.map(entry => entry.Male);
        const totalFemale = sortedData.map(entry => entry.Female);
        setChartData({
            labels,
            datasets: [
                {
                    label: 'Male',
                    data: totalMale,
                    backgroundColor: '#6EA4BD'
                },
                {
                    label: 'Female',
                    data: totalFemale,
                    backgroundColor: '#E65C2D'
                },
            ],
        });
    }, [countsByAgeAndGender]);

    const options = {
        responsive: true,
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Age',
                },
                stacked: false,
            },
            y: {
                stacked: false,
            },
        },
    };

    return (
        <div style={{ height: '400px', display: 'flex', justifyContent: 'center'}}> 
            {chartData && <Bar data={chartData} options={options} />}
        </div>
    );
};

export default GroupedBarChart;